import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllInspecaoPatrimonioItensUseCase } from "../../../presentation/useCases/read/get_all_inspecao_patrimonio_itens_use_case";
import { InspecaoPatrimonioItensModel } from "../../models/Inspecao_patrimonio_itens";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";


/**
 * GetAllInspecaoPatrimonioItensUseCase
 */

export class GetAllInspecaoPatrimonioItensUseCase
  extends BasePaginatedUseCase<InspecaoPatrimonioItensModel>
  implements IGetAllInspecaoPatrimonioItensUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) {
    super();
  }

  async getAllInspecaoPatrimonioItens(
    idInspecaoPatrimonio: number | null,
    status: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllInspecaoPatrimonioItens(
      idInspecaoPatrimonio,
      status,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
